import { render, staticRenderFns } from "./Valuation.vue?vue&type=template&id=985f5bc4&scoped=true"
import script from "./Valuation.vue?vue&type=script&lang=js"
export * from "./Valuation.vue?vue&type=script&lang=js"
import style0 from "./Valuation.vue?vue&type=style&index=0&id=985f5bc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985f5bc4",
  null
  
)

export default component.exports